import { RegionAudioManager } from "../operators/RegionAudioOperator";
import { SoundEffectManager } from "../operators/SoundEffectOperator";
import { RideAudioManager } from "../operators/RideaudioOperator";

export const SliderManager = {
  volumeRegion: 0.5,
  volumeEffects: 0.5,
  volumeMaster: 0.5,

  setVolumeLevels(region, effects, master) {
    this.volumeRegion = region;
    this.volumeEffects = effects;
    this.volumeMaster = master;

    RegionAudioManager.updateRegionVolume(region * master);
    SoundEffectManager.updateEffectsVolume(effects * master);
    RideAudioManager.updateRideVolumeOnSlider(effects * master);
  }
};
